// extracted by mini-css-extract-plugin
module.exports = {"page":"DetailEdit_page_1aUkP","card-wrapper":"DetailEdit_card-wrapper_2deBl","footer":"DetailEdit_footer_fGoQR"};